import axios from 'axios'
import { format } from 'date-fns'
import { Row } from './convertSchedules'
import { Time, makeUrlParams } from 'utils'

export type Conditions = {
  equipment_ids: string[]
  from: Date
  to: Date
}

async function fetchSchedules(headers: any, factory_id: number, conditions: Conditions): Promise<Row[]> {

  return axios.get(`/v0/factories/${factory_id}/calendar-scheduled-processes`, {
    headers: headers,
    params: {
      start_date: conditions.from.toISOString(),
      end_date: conditions.to.toISOString(),
    }
  })
    .then((res) => {
      if (Object.keys(res.data).length) {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].end_date = Time.utcToHtmlDatetimeLocal(res.data[i].end_date);
          res.data[i].start_date = Time.utcToHtmlDatetimeLocal(res.data[i].start_date);
        }
        return res.data;
      } else {
        return [];
      }
    })
    .catch((reason) => {
      throw reason
    })
}

export default fetchSchedules
